<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <a class="nav-link" style="cursor: pointer" @click="logout">
        <i class="nc-icon nc-button-power"></i>
        <span class="d-lg-none">CERRAR SESIÓN</span>
      </a>
    </li>
    <li>
      <a class="nav-link" style="cursor: pointer" @click="refresh()">
        <span style="padding-left: 50px;" class="d-lg-none">ACTUALIZAR</span>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'mobile-menu',
  methods: {
    logout() {
      window.localStorage.removeItem('jwt_user');
      window.localStorage.removeItem('jwt_licencia');
      window.localStorage.removeItem('jwt_token');
      location.href = location.origin + '/login';
    },
    refresh() {
      this.$root.$emit("getList");
    },
  },
}
</script>
<style></style>
